import axios from "axios";
import { getAuth } from "firebase/auth";

const payout = axios.create({
	baseURL: process.env.REACT_APP_URL_API_PAYOUT,
	headers: {
		"content-type": "application/json",
	},
});

payout.interceptors.request.use(async (config) => {
	const accessToken= localStorage.getItem('accessToken'); 
	let token = accessToken ? accessToken : null;
	const currentUser = getAuth().currentUser;
	if (currentUser !== null){
		token = currentUser.accessToken;
		config.headers.Authorization = `Bearer ${token}`;
	}
	else if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	} else {
		config.headers.Authorization = null;
	}

	return config;
});

export default payout;
